import React, { useEffect } from "react";
import { X } from "lucide-react";

// Generic centered modal with a dark sheet. Closes on overlay click / Esc.
export default function Modal({ open, onClose, title, children, maxWidth = "max-w-lg", testId }) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === "Escape") onClose && onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/70 p-0 sm:p-4"
      onClick={onClose}
      data-testid={testId ? `${testId}-overlay` : undefined}
    >
      <div
        className={`w-full ${maxWidth} bg-[#1e293b] border border-[#334155] rounded-t-2xl sm:rounded-2xl shadow-2xl max-h-[90vh] overflow-y-auto`}
        onClick={(e) => e.stopPropagation()}
        data-testid={testId}
      >
        {title !== undefined && (
          <div className="flex items-center justify-between px-5 py-4 border-b border-[#334155] sticky top-0 bg-[#1e293b] z-10">
            <h3 className="text-lg font-bold text-white">{title}</h3>
            <button
              onClick={onClose}
              className="w-9 h-9 rounded-full bg-[#0f172a] flex items-center justify-center text-[#9ca3af] hover:text-white"
              data-testid={testId ? `${testId}-close` : undefined}
              aria-label="Close"
            >
              <X size={20} />
            </button>
          </div>
        )}
        <div className="p-5">{children}</div>
      </div>
    </div>
  );
}
